import { abbreviateNumber } from "@/utils";

interface AreasListProps {
  areas: any[];
}

export function AreasList(props: AreasListProps) {
  return (
    <ul>
      {props.areas.map((area) => {
        return (
          <li key={area.name} className="flex items-center justify-between mt-1 text-white">
            <p>{area.name}</p>
            <span>{abbreviateNumber(area.rate)}</span>
          </li>
        );
      })}
    </ul>
  );
}
